window.GoCardless = {
	
	/**
	 * @desc form init - staff only - listing mandates
	 * @returns {undefined}
	 */
	prepareFilterForm: function(){
		
		var options = {
			success:function(data){
				GoCardless.processFilterForm(data);
			}, 
			dataType:"json"
		};
		MyForm.prepare("mandatesFilterForm", "gocardless_mandates&action=updateListing", options);
		Qtip.init();
	},
	
	processFilterForm: function(data){
		Listing.refresh("mandatesListing", data, data.mandates_metadatas);
		Qtip.init();
	},
	
	/**
	 * 
	 * @returns {undefined}@desc form init - staff only - listing payments
	 */
	prepareDirectDebitFilterForm: function(){
		var options = {
			success:function(data){
				GoCardless.processDirectDebitFilterForm(data);
			}, 
			dataType:"json"
		};
		MyForm.prepare("directdebitsFilterForm", "gocardless_gocardlessDirectdebits&action=updateListing", options);
	},
	
	processDirectDebitFilterForm: function(data){
		Listing.refresh("directdebitsListing", data, data.directdebits_metadatas);
	},
	
	prepareMassForm : function(){
		
		MyFacture.startWait();
		
		var params = {
			searching	: false
		};
		
		if(Loc.uilang == 'fr'){
			params["language"] = {
				url : 'http://cdn.datatables.net/plug-ins/1.10.16/i18n/French.json'
			};
		}
		
		$('.datatable').DataTable(params);
		
		MyFacture.stopWait();
		
		GoCardless.processMassImportForm('mandate-import-matched');
		GoCardless.processMassImportForm('mandate-import-unmatched');
		
	},
	
		
	/**
	 * 
	 * @param {type} formId
	 * @returns {undefined}
	 */
	processMassImportForm : function(formID){
		
		MyFacture.customForm('#'+formID);
		
		var formID	= formID;
		var opts	= {
			data : {
				action	: 'recordMassImport'
			},
			dataType : 'json',
			beforeSubmit : function(){
				MyFacture.startWait();
			},
			success : function(data){
				
				MyFacture.stopWait();

				var html = '<table class="table">';
				html += '<tr>';
					html += '<th>' + Loc.g("Mandats créés") + '</th> <td>' + data.created.length + '</td>';
				html += '</tr>';
				html += '<tr>';
					html += '<th>' + Loc.g("Mandats non créés (déjà dans votre compte)") + '</th> <td>' + data.notcreated.length + '</td>';
				html += '</tr>';
				html += '</table>';

				MyWindow.close();
				MyWindow.alert(html, {type : 'confirm'});
				Listing.update('mandatesListing');
			}
		};

		MyForm.prepare(formID, 'gocardless_mandates', opts, false);
		
	},
	
	
	/**
	 * @desc popup confirmation after mandate creation
	 * @returns {undefined}
	 */
	addMandateConfirmation : function(){
		MyWindow.alert(Loc.g("Le mandat à bien été créé."), {type : 'confirm'});
	},
	
	/**
	 * 
	 */
	before_massImportMandates : function(){
		
		var options = {
			type : 'info',
			buttons : [
				{
					text : Loc.g('Non'), 
					'class' : 'btn btn-default',
					click : function(){
						$(this).dialog('close');
					}
				},
				{
					text : Loc.g('Oui'), 
					'class' : 'btn btn-primary',
					click : function(){
						Utils.relocate('/?_f=gocardless_mandates&action=massImport');
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g('Pour chaque mandat présent sur votre compte GoCardless, nous allons chercher une correspondance avec un client dans votre compte Sellsy.') + '<br>' + Loc.g('La recherche peut être plus ou moins longue en fonction du nombre de client dans votre compte.'), options);
		
	},
	
	/**
	 * 
	 * @returns {undefined}
	 */
	importPopup : function(thirdid){
		
		var options = {
			title	: Loc.g("Importer des mandats"),
			buttons	: [
				{
					text : Loc.g("Fermer"), 
					'class' : 'btn btn-default',
					click :function(){
						MyWindow.close();
					}
				},
				{
					text : Loc.g("Importer"), 
					class : 'btn btn-primary',
					click :function(){
						$('#mandate-import').submit();
					}
				}
			],
			callback : function(data){

				MyFacture.customForm('#mandate-import');

				var formID	= 'mandate-import';
				var opts	= {
					data : {
						action	: 'recordImport', 
					},
					dataType : 'json',
					success : function(data){
						
							var html = '<table class="table">';
						html += '<tr>';
							html += '<th>' + Loc.g("Mandats créés") + '</th> <td>' + data.created.length + '</td>';
						html += '</tr>';
						html += '<tr>';
							html += '<th>' + Loc.g("Mandats non créés (déjà dans votre compte)") + '</th> <td>' + data.notcreated.length + '</td>';
						html += '</tr>';
						html += '</table>';
						
						MyWindow.close();
						MyWindow.alert(html, {type : 'confirm'});
						Listing.update('mandatesListing');
					}
				};

				MyForm.prepare(formID, 'gocardless_mandates', opts, false);

			},
			width: 900
		};
		
		var fileOpt = {
			action		: "importPopup",
			thirdid		: thirdid
		};
		
		MyWindow.load("gocardless_mandates", fileOpt, options);
	
	},
	
	/**
	 * 
	 * @returns {undefined}
	 */
	searchMandatesByCustomerId : function(){
		
		var customerId = $('#gocardless_customerid').val();
		
		if(customerId){
			
			MyFacture.post('gocardless_mandates', {action: "searchMandatesByCustomerId", customerId : customerId}, function (data) {
				$('#mandates-container .mandate-container').html(data.mandates);
			}, "json");

		}
		
	},
	
	
	/**
	 * 
	 * @param {type} mandateId
	 * @returns {undefined}
	 */
	cancelMandate : function(mandateId){
		
		var options = {
			type : 'warning',
			buttons : [
				{
					text : Loc.g('Non'), 
					'class' : 'btn btn-default',
					click : function(){
						$(this).dialog('close');
					}
				},
				{
					text : Loc.g('Oui'), 
					'class' : 'btn btn-primary',
					click : function(){
						MyFacture.post('gocardless_mandates', {action : 'cancel', mandateId : mandateId}, function(data){
							
							if(data.status && data.status == 'error'){
								GoCardless.handerError(Loc.g("Le mandat n'a pas pu être annulé"), data.message, data.more);
							} else {
								Utils.reload();
							}
							
						}, 'json');
						$(this).dialog('close');
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g('Voulez-vous vraiment annuler ce mandat ? Les paiements associés à ce mandat seront également annulés.'), options);
	},
	
	/**
	 * 
	 * @param {type} mandateId
	 * @returns {undefined}
	 */
	deleteMandate : function(mandateId){
		
		var options = {
			type : 'warning',
			buttons : [
				{
					text : Loc.g('Non'), 
					'class' : 'btn btn-default',
					click : function(){
						$(this).dialog('close');
					}
				},
				{
					text : Loc.g('Oui'), 
					'class' : 'btn btn-primary',
					click : function(){
						MyFacture.post('gocardless_mandates', {action : 'delete', mandateId : mandateId}, function(data){
							
							if(data.status && data.status == 'error'){
								GoCardless.handerError(Loc.g("Le mandat n'a pas pu être supprimé"), data.message, data.more);
							} else {
								Listing.update('mandatesListing');
							}
							
						}, 'json');
						$(this).dialog('close');
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g('Voulez-vous vraiment supprimer ce mandat ?'), options);
		
	},
	
	/**
	 * 
	 * @param {type} directdebitId
	 * @returns {undefined}
	 */
	cancelDirectdebit : function(directdebitId){
		
		var options = {
			type : 'warning',
			buttons : [
				{
					text : Loc.g('Non'), 
					'class' : 'btn btn-default',
					click : function(){
						$(this).dialog('close');
					}
				},
				{
					text : Loc.g('Oui'), 
					'class' : 'btn btn-primary',
					click : function(){
						MyFacture.post('gocardless_gocardlessDirectdebits', {action : 'cancel', directDebitId : directdebitId}, function(data){
							
							if(data.status && data.status == 'error'){
								GoCardless.handerError(Loc.g("Le prélèvement n'a pas pu être annulé"), data.message, data.more);
							} else {
								Utils.reload();
							}
							
						}, 'json');
						$(this).dialog('close');
					}
				}
				
			]
		};
		
		MyWindow.alert(Loc.g('Voulez-vous vraiment annuler ce prélèvement ?'), options);
		
	},
	
		/**
	 * 
	 * @param {type} directdebitId
	 * @returns {undefined}
	 */
	retryDirectdebit : function(directdebitId){
		
		var options = {
			type : 'warning',
			buttons : [
				{
					text : Loc.g('Non'), 
					'class' : 'btn btn-default',
					click : function(){
						$(this).dialog('close');
					}
				},
				{
					text : Loc.g('Oui'), 
					'class' : 'btn btn-primary',
					click : function(){
						MyFacture.post('gocardless_gocardlessDirectdebits', {action : 'retry', directDebitId : directdebitId}, function(data){
							
							if(data.status && data.status == 'error'){
								GoCardless.handerError(Loc.g("Le prélèvement n'a pas pu être réiterer"), data.message, data.more);
							} else {
								Utils.reload();
							}
							
						}, 'json');
						$(this).dialog('close');
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g('Voulez-vous vraiment réiterer ce prélèvement ? Vous ne pouvez le faire que 3 fois'), options);
		
	},
	
	/**
	 * @desc open the gocardless pref popup
	 * @returns {undefined}
	 */
	loadPrefs : function(){
		var formID = '';
		
		var options = {
			title	: Loc.g("Préférences GoCardless"),
			buttons	: [
				{text : Loc.g("Fermer"), click :function(){MyWindow.close();}}
			],
			width: 500
		};
		
		var fileOpt = {action:"connection"};
		MyWindow.load("gocardless_prefs", fileOpt, options);
	},
	
	/**
	 * @desc disconnect gc from sellsy :(
	 * @returns {undefined}
	 */
	disconnect : function(){
		var options = {
			type : 'warning',
			buttons : [
				{
					text : Loc.g('Non'), 
					'class' : 'btn btn-default',
					click : function(){
						$(this).dialog('close');
					}
				},
				{
					text : Loc.g('Oui'), 
					'class' : 'btn btn-primary',
					click : function(){
						MyFacture.post('/gocardless/prefs/disconnect', {}, function(){
                            Utils.relocate("/gocardless/prefs/connect");
						}, 'json', undefined, false);
						$(this).dialog('close');
					}
				}
			]
		}
		MyWindow.alert(Loc.g('Voulez-vous vraiment déconnecter votre compte GoCardless ?'), options);
	},
	
	handler : {},

	/**
	 * 
	 * @param {type} doctype
	 * @param {type} docid
	 * @returns {undefined}
	 */
	loadDocTab : function(doctype, docid){
		
		if(!$('#directdebit').html()){
			
			$.post('/?_f=gocardless_gocardlessDirectdebits', {action : 'docTab', doctype : doctype, docid : docid}, function(data){
				
				if(data.error){
					$('#directdebit').html(data.error);
				} else {
					
					$('#directdebit').html(data.tab);
					$('#directdebitListing').html(data.listing);

					Listing.init(data.prefix);
					GoCardless.prepareDocTabFilterForm(data.listingname, docid, doctype);

					// this will show an error if the first deadline is before the possible charge date of the debit
					GoCardless.showNextChargeDateAlert();

					MyFacture.customForm('#directdebit');
					MyFacture.initQtipDirectDebitLog();

					var formID	= 'scheduleDebitForm';
					var opts	= {
						data : {
							action	: 'recordScheduleDebitForm', 
							doctype : doctype, 
							docid	: docid
						},
						beforeSubmit : function(){
							MyFacture.startWait();
						},
						dataType : 'json',
						success : function(data){
							
							MyFacture.stopWait();
							if(data.status && data.status == 'error'){
								GoCardless.handerError(Loc.g("Le prélèvement n'a pas pu être programmé"), data.message, data.more);
							} else if(data.form && data.form.status == 'failed'){

								var msg = '';

								if(data.form.fields && data.form.fields.length > 0){
									msg = data.form.fields[0].msg;
								} else {
									msg = data.form.msg;
								}

								GoCardless.handerError(Loc.g("Le prélèvement n'a pas pu être programmé"), msg);

							} else {
								Utils.relocate('/?_f=' + doctype + 'Overview&id=' + docid + '&tab=gocardless');
							}

						}
					};

					MyForm.prepare(formID, 'gocardless_gocardlessDirectdebits', opts, false);
					
				}


			}, 'json');
			
		}
		
	},
	
	/**
	 * 
	 * @returns {undefined}
	 */
	prepareDocTabFilterForm: function(listingName, docid, doctype){
		
		var options = {
			success : function(data){
				GoCardless.processDocTabFilterForm(listingName, data);
			}, 
			dataType:"json"
		};
		MyForm.prepare(listingName + "FilterForm", "gocardless_gocardlessDirectdebits&action=updateTabDirectDebitListing&docid="+docid+"&doctype="+doctype, options);
	},
	
	/**
	 * 
	 * @param {type} data
	 * @returns {undefined}
	 */
	processDocTabFilterForm: function(listingName, data){
		Listing.refresh(listingName + "Listing", data, data.directdebits_metadatas);
	},
	
	/**
	 * 
	 * @param {type} error
	 * @param {type} more
	 * @returns {undefined}
	 */
	handerError : function(message, error, more){
		
		var errorMsg = message;
		
		if(error){
			errorMsg += ' : ' + error;
		}
		
		if(more){
			errorMsg += '<br><br>';
			errorMsg += '<b>' + Loc.g("Plus d'informations") + ' : </b>'+ more;
		}
		
		MyWindow.alert(errorMsg, {type : 'error'});
	},
	
	/**
	 * 
	 * @param {type} e
	 * @returns {undefined}
	 * 
	 */
	showNextChargeDateAlert : function(e, alwaysShow){
		
		if(e){
			
			if(e.currentTarget){
				var currentTarget = $(e.currentTarget);
			} else {
				var currentTarget = e;
			}
			
		}
		
		var format = "DD/MM/YYYY";
		if($('#dateformat').val() == 'mdy'){
			var format = "MM/DD/YYYY";
		}
		
		if(!currentTarget){
			var currentTarget			= $("select[name='mandateid']");
		}
		
		var nextPossibleChargeDate	= currentTarget.find(":selected").data('next_charge_date');
		var firstDeadLine			= $('.gocardlessdeadlines').first().val();
		var deadLineUnix			= moment(firstDeadLine, 'dd/mm/yyyy').unix(); 

		if((alwaysShow === true && nextPossibleChargeDate > 0) || (deadLineUnix < nextPossibleChargeDate)){
			$("#gocardless-nextchargedate").html( moment.unix(nextPossibleChargeDate).format(format) );
			$("#gocardless-alertchargedate").removeClass('hidden');
		} else{
			$("#gocardless-alertchargedate").addClass('hidden');
		}
		
	},
	
	/**
	 * 
	 * @param {type} rowSelection
	 * @returns {undefined}
	 */
	recordMassDeleteMandate : function(rowSelection){
		
		var msg = Loc.g("L'ensemble des mandats sélectionnés dont le status est 'invalide' seront supprimés.");
		
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			width		: 350,
			title		: Loc.g("Supprimer"),
			buttons: [
                {
                    text: Loc.g("Fermer"),
					'class' : 'btn btn-default',
                    click: function () {
                        $(this).dialog("close");
                    }
                },
                {
					text: Loc.g("Valider"),
					'class' : 'btn btn-primary',
					click: function () {
						MyWindow.wait('alertWindow');
						MyFacture.post('gocardless_mandates', {action: "massDelete", rows : rowSelection}, function (data) {
							MyWindow.close('alertWindow');
							Listing.update('mandatesListing');
						}, "json");
					}
				}
			]
		};

		MyWindow.alert(msg, options);
		
	},
	
	
	/**
	 * 
	 * @param {type} rowSelection
	 * @returns {undefined}
	 */
	massRetried: function (rowSelection){
	
		var msg = Loc.g("L'ensemble des prélèvements sélectionnés dont le status est 'échec ' seront réitérés.");
		
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			width		: 350,
			title		: Loc.g("Réitérer les prélèvements"),
			buttons: [
                {
                    text: Loc.g("Fermer"),
					'class' : 'btn btn-default',
                    click: function () {
                        $(this).dialog("close");
                    }
                },
                {
					text: Loc.g("Valider"),
					'class' : 'btn btn-primary',
					click: function () {
						MyWindow.wait('alertWindow');
						MyFacture.post('gocardless_gocardlessDirectdebits', {action: "massRetried", rows : rowSelection}, function (data) {

							MyWindow.awake('alertWindow');

							if(data.paymentRetried && data.paymentRetried.length > 0){

								var parameters = {
									type	: 'confirm',
									width	: 450,
									buttons		: [{text : Loc.g("Ok"), click : function(){$(this).dialog("close");Listing.update('directdebitsListing');}}]
								};


								var recap = Loc.g("Les paiements suivant ont été réitérés") + ' : <br><br>';

								recap += '<ul>';

								$.each(data.paymentRetried, function( index, value ) {
									recap += '<li>-' + value.id + ' ' + Loc.g("du document") + ' ' + value.doc + '</li>';
								});

								recap += '</ul>';

								MyWindow.alert(recap, parameters);

							} else {

								var parameters = {
									type : 'confirm',
									buttons		: [{text : Loc.g("Ok"), click : function(){$(this).dialog("close");}}]
								};

								MyWindow.alert(Loc.g("Aucun paiement n'a été réitéré"), parameters);

							}

						}, "json");
					}
				}
			]
		};

		MyWindow.alert(msg, options);	
	},	
	
	
	/**
	 * 
	 * @param {type} rowSelection
	 * @returns {undefined}
	 */
	massMandateReminder : function(rowSelection){
		
		var msg = Loc.g("Un email d'invitation à la prise de mandat va être envoyé à l'ensemble des clients sélectionnés. Êtes-vous sûr ?");
		
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			width		: 350,
			title		: Loc.g("Inviter à la prise de mandat"),
			buttons: [
				{
					text: Loc.g("Fermer"),
					'class' : 'btn btn-default',
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Valider"),
					'class' : 'btn btn-primary',
					click: function () {
						MyWindow.wait('alertWindow');
						MyFacture.post('gocardless_mandates', {action: "massMandateReminder", rows : rowSelection}, function (data) {
							MyWindow.awake('alertWindow');
							MyWindow.alert(Loc.g("Emails envoyés !"), {type : 'confirm'});
						});
					}
				}
			]
		};

		MyWindow.alert(msg, options);	
		
	},
	
	/**
	 * 
	 * @param {type} rowSelection
	 * @returns {undefined}
	 */
	recordMassDirectdebits : function(rowSelection){
		
		var msg = Loc.g("Les prélèvements seront programmés aux échéances des documents. Le mandat par défaut du client sera utilisé.");
		
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			width		: 350,
			title		: Loc.g("Programmer des prélèvements"),
			buttons: [
				{
					text: Loc.g("Fermer"),
					'class' : 'btn btn-default',
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Programmer"),
					'class' : 'btn btn-primary',
					click: function () {
						MyWindow.wait('alertWindow');
						MyFacture.post('gocardless_gocardlessDirectdebits', {action: "massDirectdebits", rows : rowSelection}, function (data) {

							MyWindow.awake('alertWindow');
                        
							var popupTxt = '';
                            
                            if(data.result) {
                                popupTxt = data.result;
                            }
							
							var parameters = {
								width		: 650,
								title		: 'GoCardless',
								buttons		: [{
										text : Loc.g("Ok"), 
										'class' : 'btn btn-default',
										click : function(){
											$(this).dialog("close");
											Listing.update('docinvoicesListing');
										}
								}]	
							};

							MyWindow.alert(popupTxt, parameters);
							
						}, "json");
					}
				}
			]
		};

		MyWindow.alert(msg, options);	
		
	}
};


window.GCThird = {
	
	/**
	 * @desc form init - third only
	 * @returns {undefined}
	 */
	prepareFilterForm: function(){
		Qtip.init();
		var options = {
			success:function(data){
				GCThird.processFilterForm(data);
			}, dataType:"json"
		};
        MyForm.prepare("mandatesFilterForm", "/thirdspace/debit", options, false, undefined, false);
	},
	
	processFilterForm: function(data){
		Listing.refresh("mandatesListing", data, data.mandates_metadatas);
		Qtip.init();
	},
	
	
	/**
	 * @desc right click - set mandate as default
	 * @returns {undefined}
	 */
	setMandateAsDefault : function(mandateId){
		
		var options = {
			type : 'warning',
			buttons : [
				{
					text : Loc.g('Oui'), 
					click : function(){
						MyFacture.post('gocardless_mandates', {action : 'setAsDefault', mandateId : mandateId}, function(data){
							
							if(data.status && data.status == 'error'){
								MyWindow.alert(data.message, {type : 'warning'});
							} else {
								Listing.update('mandatesListing');
							}
							
						}, 'json');
						$(this).dialog('close');
					}
				},
				{
					text : Loc.g('Non'), 
					click : function(){
						$(this).dialog('close');
					}
				}
			]
		}
		MyWindow.alert(Loc.g('Voulez-vous vraiment mettre ce mandat en tant que mandat par défaut'), options);
	},
	
	/**
	 * 
	 * @param {type} thirdid
	 * @returns {undefined}
	 */
	loadTab : function(thirdid){
		
		var prefilter = {'third' : thirdid};
		
		if($('#mandatesContainer').html() == ''){
			var options = {
				action		: "loadListingTab",
				listing		: 'mandates',
				context		: 'thirdaccess',
				prefilter	: JSON.stringify(prefilter),
			};

			MyFacture.post('tabs', options, function (data) {

				$('#mandatesContainer').html(data.listing);
				Listing.init(data.prefix);
				
				var options = {
					data : {
						action		: 'updateListingTab', 
						thirdid		: thirdid, 
						listing		: 'mandates',
						context		: 'thirdaccess',
						prefilter	: JSON.stringify(prefilter)
					},
					success: function (data) {
						Listing.refresh(data.listingName, data, data[data.metadatasName]);
					},
					dataType: "json"
				};
				MyForm.prepare(data.listingname + "FilterForm", "tabs", options);
				
				MyFacture.customForm('#mandatesContainer');
			}, 'json');
		}

	},

	/**
	 * @param integer mandateid
	 */
	unlinkMandate : function(mandateid) {

		var options = {
			type : 'warning',
			buttons : [
				{
					text : Loc.g('Oui'), 
					click : function(){

						MyFacture.post('gocardless_mandates',{
							action : "unlinkThirdMandate",
							mandateId : mandateid
						}, function(response){
							
							if(response.status === "success") {
								Push.success(response.message);
 							} else {
								Push.error(response.message);
							}
 
							Listing.update('mandatesListing');
						},'json');

						$(this).dialog('close');

					}
				},
				{
					text : Loc.g('Non'), 
					click : function(){
						$(this).dialog('close');
					}
				}
			]
		
		}
		MyWindow.alert(Loc.g('Voulez-vous vraiment délier ce mandat de votre client ?'), options);
	}
};
